import { noTokenPost } from "./base";

// 获取注册code
export const securityVliadCode = (data?: any) => noTokenPost('https://account.1wan.cn/Login/securityVliadCode', data, {
    "X-Requested-With": "XMLHttpRequest",
    'Content-Type': 'multipart/form-data'
});
// 注册
export const noteregister = (data?: any) => noTokenPost('https://account.1wan.cn/Register/noteregister', data, {
    "X-Requested-With": "XMLHttpRequest",
    'Content-Type': 'multipart/form-data'
});